/*
 * This file is part of glowingblue/datavis.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class DataVis extends Model {
	id = Model.attribute('id');
	name = Model.attribute('name');
	token = Model.attribute('token');
	embedUrl = Model.attribute('embedUrl');
}
